export default __webpack_public_path__ + "static/media/IMG10.cfe5bbd8.png";